// Identificação do cliente no Totem/Balcão (auth: o totem roda logado).
import axios from "axios";

const API = "/api";
const auth = () => ({ headers: { Authorization: `Bearer ${localStorage.getItem("token")}` } });

export const totemApi = {
  /** 200 = cliente; 404 = não cadastrado; 400 = CPF inválido. */
  buscarPorCpf: (cpf) => axios.get(`${API}/clientes/por-cpf/${cpf}`, auth()),
  criarCliente: (data) => axios.post(`${API}/clientes`, data, auth()),
  /** Busca do Balcão (a mesma das Mesas): nome, telefone, CPF ou e-mail; até 8. */
  buscarClientes: (termo) => axios.get(`${API}/clientes/search/${encodeURIComponent(termo)}`, { ...auth(), params: { leve: 1, limite: 8 } }),
  /** Mídias da tela de descanso (placement=totem). */
  midias: () => axios.get(`${API}/cardapio-banners`, { ...auth(), params: { placement: "totem" } }),
  /** Banner do topo do cardápio (placement=totem_cardapio). */
  bannersCardapio: () => axios.get(`${API}/cardapio-banners`, { ...auth(), params: { placement: "totem_cardapio" } }),
};
